import { render, staticRenderFns } from "./WfCorpVehicleModal.vue?vue&type=template&id=8bce2b54&"
import script from "./WfCorpVehicleModal.vue?vue&type=script&lang=js&"
export * from "./WfCorpVehicleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports